import React from 'react';
import TimesheetForm from '../../components/features/attendance/TimesheetForm';

const TimesheetPage = () => {
  return <TimesheetForm />;
};

export default TimesheetPage;